import { Component } from '@angular/core';
import { DataLoaderService, PriceCalculationService } from '../expert-service-call.index';
import { ExpertModeOptionSelection } from '../expert-mode-options/expert-mode-option-selection';
@Component({
    selector: 'expert-validation',
    templateUrl: './expert-validation.template.html',
    styleUrls: ['./expert-validation.component.css'],
})
export class ExpertValidation {
    public errMessage;
    public expertSuggestionList = [];
    constructor(private dataLoaderService: DataLoaderService, private priceCalculationService: PriceCalculationService,
        private expertModeOptionSelection: ExpertModeOptionSelection) { }

    validate() {
        this.dataLoaderService.flagDictionary.openExpertValidateFlag = false;
        this.expertModeOptionSelection.loadSuggestions();
    }
    cancel() {
        this.dataLoaderService.flagDictionary.confirmValidateFlag = false;
        this.dataLoaderService.flagDictionary.expertValidateFlag = true;
        this.dataLoaderService.flagDictionary.openExpertValidateFlag = false;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/expert-screen-components/expert-validation/expert-validation.component.ts